export default "__VITE_ASSET__DX5drz5y__"